var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"remove-member"},[_c('div',{staticClass:"remove-member-warp"},[_c('account-select-wrapper',{ref:"removeSelectWrapper",attrs:{"contacts":_vm.imTeamMemberCheckList,"type":"remove"},on:{"operate":_vm.operate}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-505dd065","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/im/team/member/TeamMemberRemove.vue
// module id = null
// module chunks = 